import { showToast } from './Toast'
import { useI18n } from '../i18n/useI18n'
import type { StoreRecoReason } from '../services/api'

// #8: 実データ推薦の理由バッジ。色・アイコンは plan カタログ (#1253/#1263) の
// recoReason バッジと揃える — 「なぜ勧められたか」を面をまたいで同じ見た目で示す。
// タップで根拠の説明トーストを出す (#8 FB: 「同じ国の人に人気」が位置情報由来と
// 誤解された — 実際はプロフィールの自己申告国籍。誤解される表示には説明を付ける)。
const STYLES: Record<
  StoreRecoReason,
  { cls: string; icon: string; key: string; explainKey: string }
> = {
  your_taste: {
    cls: 'bg-gold/15 text-gold', icon: '✨',
    key: 'stores.recoForYou', explainKey: 'stores.recoExplainForYou',
  },
  compatriot: {
    cls: 'bg-navy/10 text-navy', icon: '🌏',
    key: 'stores.recoHomeCountry', explainKey: 'stores.recoExplainHomeCountry',
  },
  same_age: {
    cls: 'bg-gray-100 text-text-secondary', icon: '👥',
    key: 'stores.recoSameAge', explainKey: 'stores.recoExplainSameAge',
  },
  popular: {
    cls: 'bg-matcha/15 text-matcha', icon: '',
    key: 'stores.recoPopular', explainKey: 'stores.recoExplainPopular',
  },
}

export default function StoreRecoBadge({
  reason,
  className = '',
}: {
  reason: StoreRecoReason | null | undefined
  className?: string
}) {
  const { t } = useI18n()
  if (!reason) return null
  const style = STYLES[reason]
  if (!style) return null // backend が理由を増やしても表示だけ落として壊れない
  return (
    <span
      role="button"
      tabIndex={0}
      aria-label={t(style.explainKey)}
      onClick={(e) => {
        // 店舗カード全体が <button> のため、タップが詳細画面への遷移に化けないよう止める
        e.preventDefault()
        e.stopPropagation()
        showToast({ type: 'info', message: t(style.explainKey), duration: 4000 })
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          e.stopPropagation()
          showToast({ type: 'info', message: t(style.explainKey), duration: 4000 })
        }
      }}
      className={`rounded-full px-1.5 py-0.5 text-[10px] font-medium ${style.cls} ${className}`}
    >
      {style.icon && `${style.icon} `}
      {t(style.key)}
    </span>
  )
}
